import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import GlobalAccounts from "./GlobalAccounts";
import Wallets from "./Wallets";
import styles from "./AccountDetail.module.css";

const AccountDetail = ({ userId }) => {
  const [accountStatus, setAccountStatus] = useState(null);
  const [activeKey, setActiveKey] = useState("0");

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className={styles.accountDetailContainer}>
      
      <Accordion activeKey={activeKey} className={styles.accordionContainer}>
        <Accordion.Item eventKey="0">
          <Accordion.Header 
            onClick={() => handleToggle("0")}
            className={styles.accordionHeader}
          >
            Global Account
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            <GlobalAccounts userId={userId} onAccountStatus={(s) => setAccountStatus(s)} />
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
          <Accordion.Header 
            onClick={() => handleToggle("1")}
            className={styles.accordionHeader}
          >
            Wallets
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            <Wallets userId={userId} accountStatus={accountStatus}/>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default AccountDetail;